import { render, staticRenderFns } from "./PdfButton.vue?vue&type=template&id=679582b4"
import script from "./PdfButton.vue?vue&type=script&lang=js"
export * from "./PdfButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports